export default {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '订单号',
                value: 'orderNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '状态',
                value: 'applystatus',
                unfold: true,
                type: 'select',
                options: [
                    {
                        value: 1,
                        label: '待审核'
                    },
                    {
                        value: 2,
                        label: '申请成功'
                    },
                    {
                        value: 3,
                        label: '驳回'
                    }
                ],
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                timeNum: 3,
                span: 7
            }
        ],
        unfoldState: false,
        advancedBtn: false,
        isControl: true
    },
    table: {
        selectBtn: true,
        fixedSeletionColumn: true,
        leftOperation: true,
        leftWidth: 94,
        maxBtnNum: 1,
        hasMaxBtnNum: true,
        height: 400,
        columns: [
            {
                label: '订单号',
                prop: 'orderNo',
                sort: true,
                width: '180px'
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: '120px'
            },
            {
                label: '用户地址',
                prop: 'receiverDetailAddr',
                sort: true,
                width: '148px'
            },
            {
                label: '网点分中心编码',
                prop: 'networkCenterCode',
                sort: true,
                width: '148px'
            },
            {
                label: '网点分中心名称',
                prop: 'networkCenterName',
                sort: true,
                width: '148px'
            },
            {
                label: '网点编码',
                prop: 'networkCode',
                sort: true,
                width: '110px'
            },
            {
                label: '网点名称',
                prop: 'networkName',
                sort: true,
                width: '148px'
            },
            {
                label: '系统计算里程',
                prop: 'planMile',
                sort: true,
                width: '120px'
            },
            {
                label: '实际里程',
                prop: 'actMile',
                sort: true,
                width: '120px'
            },
            {
                label: '费用',
                prop: 'fee',
                sort: true,
                width: '120px'
            },
            {
                label: '状态',
                prop: 'applystatusName',
                width: 100,
                sort: true
            },
            {
                label: '创建人',
                prop: 'createUserCode',
                width: 120,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            },
            {
                label: '修改人',
                prop: 'updateUserCode',
                width: 120,
                sort: true
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                width: 160,
                sort: true
            }
        ],
        action: [{
            type: 'text',
            label: '附件',
            size: 'mini',
            event: 'viewPic',
            ifHas: ''
        },
        {
            type: 'text',
            label: '驳回',
            size: 'mini',
            event: 'reject',
            ifHas: '10070002'
        },
        {
            type: 'text',
            label: '修改',
            size: 'mini',
            event: 'editMile',
            ifHas: '10070004'
        }]
    },

    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            50
        ]
    },
    searchTotalTitle: [
    ]
};
